<template lang="pug">
section
  .container__1060
    //- 切り替えタブ
    .news__tab--wrap(
      class="max-w-[1000px] mx-auto mb-[32px]"
    )
      .news__tab
        ul(class="flex !mb-[44px] !p-0")
          li(
            class="w-[50%] text-center"
          )
            button(
              data-tab="tab1",
              type="button",
              class="news__tab--cat txt__notoSB24 w-full h-[56px] lg:h-[66px] text-[#A39021] border-[2px] border-solid border-[#A39021] rounded-[10px_0_0_10px]",
              :class="activeMainTab === 'category' ? 'active' : ''"
              @click.prevent="handleMainTabClick('category')"
            ) カテゴリで探す
          li(
            class="w-[50%] text-center"
          )
            button(
              data-tab="tab2",
              type="button",
              class="news__tab--area txt__notoSB24 w-full h-[56px] lg:h-[66px] text-[#749F54] border-[2px] border-solid border-[#749F54] rounded-[0_10px_10px_0]",
              :class="activeMainTab === 'city' ? 'active' : ''"
              @click.prevent="handleMainTabClick('city')"
            ) エリアで探す
        //- 切り替えタブ中身
        .news__tab--content
          .news__tab--panel(
            data-tab="tab1",
            v-show="activeMainTab === 'category'"
          )
            .news__subtab--wrap
              .news__subtab
                ul(class="flex flex-wrap gap-[12px] md:gap-[16px_24px] lg:gap-[24px_30px] xl:gap-[24px_32px] !m-0 !p-0")
                  li(
                    class="flex-initial text-center"
                  )
                    button(
                      class="news__subtab--cat !leading-[1.2] txt__notoSB16 !text-[12px] lg:!text-[16px] inline-flex items-center justify-center min-h-[36px] lg:min-h-[44px] px-3 py-2 whitespace-nowrap text-[#A39021] border-[1px] border-solid border-[#A39021] rounded-[10px]",
                      data-tab="tab1",
                      :class="selectedCategoryId === null ? 'active' : ''"
                      @click.prevent="handleCategoryClick(null)"
                    ) すべて
                  li(
                    v-for="category in orderedCategoryList",
                    :key="category.id",
                    class="flex-initial text-center"
                  )
                    button.news__subtab--cat.txt__notoSB16(
                      data-tab="tab1",
                      class="inline-flex items-center justify-center min-h-[36px] lg:min-h-[44px] px-3 py-2 !leading-[1.2] whitespace-nowrap !text-[12px] lg:!text-[16px] text-[#A39021] border-[1px] border-solid border-[#A39021] rounded-[10px]",
                      :class="selectedCategoryId === category.id ? 'active' : ''"
                      @click.prevent="handleCategoryClick(category.id)"
                    ) {{ category.name }}

          .news__tab--panel(
            data-tab="tab2",
            v-show="activeMainTab === 'city'"
          )
            .news__subtab--wrap
              .news__subtab
                ul(class="flex flex-wrap gap-[12px] md:gap-[16px_24px] lg:gap-[24px_30px] xl:gap-[24px_32px] !m-0 !p-0")
                  li(
                    class="w-[22%] md:w-[17%] lg:w-[14%] text-center"
                  )
                    button(
                      data-tab="tab2",
                      class="news__subtab--area txt__notoSB16 !text-[12px] lg:!text-[16px] w-full h-[32px] lg:h-[42px] text-[#749F54] border-[1px] border-solid border-[#749F54] rounded-[10px]",
                      :class="!(selectedCityIds?.length) ? 'active' : ''"
                      @click.prevent="handleCityClick(null)"
                    ) すべて
                  li(
                    v-for="city in flatCityList",
                    :key="city.id",
                    class="w-[22%] md:w-[17%] lg:w-[14%] text-center"
                  )
                    button(
                      class="news__subtab--area txt__notoSB16 !text-[12px] lg:!text-[16px] w-full h-[32px] lg:h-[42px] text-[#749F54] border-[1px] border-solid border-[#749F54] rounded-[10px]"
                      data-tab="tab2",
                      :class="(selectedCityIds && selectedCityIds.includes(city.id)) ? 'active' : ''"
                      @click.prevent="handleCityClick(city.id)"
                    ) {{ city.name }}

    p(
      class="txt__notoR14 txt__black text-right !mb-[24px] lg:!mb-[32px]",
      v-if="newsList.length > 0"
    ) 全{{ meta.total }}件中、{{ meta.from }}件～{{ meta.to }}件目

    .news__items(
      v-if="newsList.length > 0"
    )
      div(
        v-for="news in newsList",
        :key="news.id",
        class=`
          border-t-[1px] border-t-solid border-t-[#8E7902]
          last:border-b-[1px] last:border-b-solid last:border-b-[#8E7902]
        `
      )
        a(
          :href="linkFor(news)",
          :target="news.external_url ? '_blank' : '_self'",
          :rel="news.external_url ? 'noopener noreferrer' : ''",
          class="news__item group block px-[20px] py-[24px]"
        )
          .news__dateCat(
            class="mb-[20px] lg:flex lg:align-center"
          )
            //- 日付
            .news__date.txt__notoM20(
              class="mb-[16px] lg:mb-0 mr-[28px] text-[#8E7902]"
            ) {{ formatDate(news.publish_at) }}

            //- カテゴリー・エリア
            .news__tagOuter(
              class="flex flex-wrap gap-x-[16px] gap-y-[8px]"
            )
              //- カテゴリー
              div(
                v-if="news.categories.length > 0",
                class="flex flex-wrap gap-x-[16px] gap-y-[8px]"
              )
                .news__tagWrap(
                  v-for="category in news.categories",
                  :key="category.id",
                  class="px-[12px] h-[33px] flex items-center justify-center bg-[#E2D3A9] rounded-[10px]"
                )
                  .news__tag.txt__notoB12.txt__black {{ category.name }}
              //- エリア
              div(
                v-if="news.cities.length > 0",
                class="flex flex-wrap gap-x-[16px] gap-y-[8px]"
              )
                .news__tagWrap(
                  v-for="city in news.cities",
                  :key="city.id",
                  class="px-[12px] h-[33px] flex items-center justify-center bg-[#C7D4B8] rounded-[10px]"
                )
                  .news__tag.txt__notoB12.txt__black {{ city.name }}

          //- タイトル
          h3.news__title.txt__notoM20.txt__black(
            class="duration-300 group-hover:!text-[#8E7902] leading-[calc(37/20)] lg:leading-[calc(28/20)]"
          ) {{ news.title }}
            //- img.inline-block(
            //-   v-if="news.external_url",
            //-   :src="`${config.filesystems.urls.gcs}/common/newWindow_gold.svg`",
            //-   alt="外部リンク",
            //-   class="ml-[16px] translate-y-[-4px]"
            //- )

      //- ページネーション
      .flex.flex-wrap.justify-center.items-center.gap-4.pt-8(
        v-if="meta.last_page > 1 && newsList.length > 0"
        class=`
          pt-[94px] lg:pt-[72px]
        `
      )
        //- 前へボタン：最初のページ以外のときだけ表示
        button(
          v-if="meta.current_page > 1",
          type="button",
          class="w-[42px] h-[42px] md:w-auto px-2 text-[#8E7902] flex items-center justify-center",
          @click.prevent="goPrev"
        )
          span(class="material-symbols-outlined !text-[16px]") arrow_back_ios

        //- ページ番号一覧（1 ～ last_page）
        template(
          v-for="pageNumber in pageNumbers",
          :key="pageNumber"
        )
          //- 現在ページ
          span(
            v-if="pageNumber === meta.current_page",
            class="border border-[#8E7902] w-[42px] h-[42px] text-center bg-[#8E7902] text-white flex items-center justify-center rounded-md"
          ) {{ pageNumber }}
          //- それ以外のページ（クリックでページ番号を変更）
          button(
            v-else,
            type="button",
            class="border border-[#8E7902] w-[42px] h-[42px] text-center text-[#8E7902] flex items-center justify-center rounded-md",
            @click="page = pageNumber"
          ) {{ pageNumber }}

        //- 次へボタン：最後のページ以外のときだけ表示
        button(
          v-if="meta.current_page < meta.last_page",
          type="button",
          class="w-[42px] h-[42px] md:w-auto px-2 text-[#8E7902] flex items-center justify-center",
          @click="goNext"
        )
          span(class="material-symbols-outlined !text-[16px]") arrow_forward_ios

    div(
      v-else
    )
      p(
        class="txt__notoSB24 txt__black text-center py-[170px] relative"
      ) 条件に該当するお知らせは見つかりませんでした。
</template>


<script setup lang="ts">
import { ref, onMounted, watch, computed } from 'vue';
import type { Category } from '@/ts/console/type/Category';
import type { City } from '@/ts/console/type/City';
import axios from 'axios';
//- お知らせの一覧
const newsList = ref<any[]>([]);

const meta = ref({
  current_page: 1,
  last_page: 1,
  from: 0,
  to: 0,
  total: 0,
})

// ページ番号の配列を作る（1 ～ meta.last_page まで）
const pageNumbers = computed(() => {
  const currentPage = meta.value.current_page;
  const lastPage = meta.value.last_page;
  const delta = 2;
  const left = currentPage - delta;
  const right = currentPage + delta + 1;
  const range: (number | string)[] = [];
  const rangeWithDots: (number | string)[] = [];
  let l: number | undefined;

  for (let i = 1; i <= lastPage; i++) {
    if (i === 1 || i === lastPage || (i >= left && i < right)) {
      range.push(i);
    }
  }

  for (const i of range as number[]) {
    if (l) {
      if (i - l === 2) {
        rangeWithDots.push(l + 1);
      } else if (i - l !== 1) {
        rangeWithDots.push('...');
      }
    }
    rangeWithDots.push(i);
    l = i;
  }
  return rangeWithDots;
})

//- カテゴリーの一覧（news / project 両方を持つ）
type CategoryWithType = Category & { type?: 'news' | 'project' };
const categoryList = ref<CategoryWithType[]>([]);
//- エリアの一覧
const cityList = ref<any[]>([]);
const page = ref(1);

const baseUrl = (window as any).baseUrl;

// メインタブの状態
// 'category'カテゴリで探すタブ
// 'area'エリアで探すタブ
const activeMainTab = ref<'category' | 'city'>('category');

// どのカテゴリが選択されているか（null = すべて）
const selectedCategoryId = ref<number | null>(null)
// どのエリアが選択されているか（null = すべて）
const selectedCityIds = ref<number[] | null>([])

onMounted(() => {
  fetchNews();
  fetchCategory();
  fetchCity();
})

//- サーバー側からお知らせの一覧を取得
const fetchNews = async () => {
  try {
    const response = await axios.get(`${baseUrl}/api/news`, {
      params: {
        per_page: 10,
        page: page.value,
        category_id: selectedCategoryId.value ?? undefined,
        city_ids: selectedCityIds.value?.length ? selectedCityIds.value : undefined,
      }
    });
    // console.log('お知らせとプロジェクトの一覧', response);
    newsList.value = response.data.data;
    meta.value = response.data.meta;
    // console.log(newsList.value, meta.value);
  } catch (error) {
    console.error('Error fetching news:', error);
  }
}

//- サーバー側からカテゴリの一覧を取得（news / project 両方）
const fetchCategory = async () => {
  try {
    const response = await axios.get(`${baseUrl}/api/category`, {
      params: {
        types: ['news', 'project'],
      }
    });
    // console.log('response', response);
    categoryList.value = (response.data || []).map((c: any) => ({
      id: Number(c.id),
      name: c.name,
      type: c.type,
    }));
    // console.log('categoryList', categoryList.value);
  } catch (error) {
    console.error('Error fetching category:', error);
  }
}

//- サーバー側からエリアの一覧を取得
const fetchCity = async () => {
  try {
    const response = await axios.get(`${baseUrl}/api/city`);

    // console.log('response city', response);

    cityList.value = response.data;
    // console.log('cityList', cityList.value);
  } catch (error) {
    console.error('Error fetching city:', error);
  }
}

// 地域ごとのオブジェクト cityList から、
// 県北 → 県央 → 県南 → その他 の順で市だけを配列にする
const flatCityList = computed(() => {
  // 並び順を決める配列
  const order = ['県北地域', '県央地域', '県南地域', 'その他'];

  const result: { id: number; name: string }[] = [];

  for(const region of order) {
    // cityList.value[region] が存在しない場合は空配列として扱う
    const cities = cityList.value?.[region as any] ?? [];
    // ... で配列を結合
    result.push(...cities);
  }

  return result;
});

/**
 * メインタブ（「カテゴリで探す」 or 「エリアで探す」）がクリックされたときの処理
 */
const handleMainTabClick = (tab: 'category' | 'city') => {
  activeMainTab.value = tab;

  if(tab === 'category'){
    // カテゴリーで探すに切り替えたときはエリアの条件をリセット
    selectedCityIds.value = [];
  } else {
    // エリアで探すに切り替えたときはカテゴリーの条件をリセット
    selectedCategoryId.value = null;

  }
  // タブを切り替えたときはページを1ページ目に戻す
  page.value = 1;
}


const handleCategoryClick = (id: number | null) => {
  selectedCategoryId.value = id;
  page.value = 1;
}

const handleCityClick = (id: number | null) => {
  if (id === null) {
    // 「すべて」選択：条件リセット
    selectedCityIds.value = [];
  } else {
    const ids = selectedCityIds.value ?? [];
    selectedCityIds.value = ids.includes(id) ? ids.filter(v => v !== id) : [...ids, id];
  }
  page.value = 1;
}

// ページ変更で再取得
// watch：
// page または selectedCategoryId が変わった瞬間に fetchNews() を実行する
// → カテゴリ切り替えや次へ/前へボタンで自動的にニュースが再取得される
// immediate: true により「初回表示時」も fetchNews() が 1 回実行される
watch([page, selectedCategoryId, selectedCityIds], fetchNews);

// formatDate：API から返ってきた日時（ISO形式）を「YYYY/MM/DD」形式に整形する
// 例：2025-11-19T01:31:05.000000Z → 2025/11/19
const formatDate = (dateString: string) => {
  if (!dateString) return '-'
  const datePart = dateString.split('T')[0] // "YYYY-MM-DD"
  return datePart.replace(/-/g, '/')
}

const goNext = () => {
  if(meta.value.current_page < meta.value.last_page){
    page.value++;
  }
}

const goPrev = () => {
  if(meta.value.current_page > 1){
    page.value--;
  }
}

// script setupに追加
const linkFor = (item: any) => {
  if (item.external_url) return item.external_url;
  if (item.detail_path) return item.detail_path;
  return item?.type === 'project'
    ? `${baseUrl}/project/${item.id}`
    : `${baseUrl}/news/${item.id}`;
};

// 表示順：news → project の順に並べ、かつ「その他」を常に最後に持ってくるカテゴリリスト
const orderedCategoryList = computed(() => {
  const order = { news: 0, project: 1 } as Record<string, number>;
  const sorted = [...categoryList.value].sort((a, b) => {
    const aOrder = order[a.type ?? 'news'] ?? 0;
    const bOrder = order[b.type ?? 'news'] ?? 0;
    if (aOrder !== bOrder) return aOrder - bOrder;
    return (a.id ?? 0) - (b.id ?? 0);
  });

  // 名前が「その他」のカテゴリを末尾に移動する
  const idx = sorted.findIndex(c => c.name === 'その他');
  if (idx === -1) return sorted;
  const copy = sorted.slice();
  const [others] = copy.splice(idx, 1);
  copy.push(others);
  return copy;
});


</script>

<style lang="sass" scoped>

</style>
